import { InfoOutlineIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { slavtUrl } from "../api/config";
import useAuthState from "../state/auth.state";

export default function ManualDownloader() {
  const { i18n, t } = useTranslation();
  const { role } = useAuthState();

  if (role === "ROLE_ADMIN") return null;

  return (
    <IconButton
      aria-label={t("common.buttons.manual")}
      icon={<InfoOutlineIcon h={5} w={5} />}
      as={Link}
      to={`${slavtUrl}/manual?lang=${i18n.language}&role=${role}`}
      target="_blank"
    />
  );
}
